// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
// 导入不需要懒加载的首屏组件
import HomeView from '../views/HomeView.vue'
import ProductView from '../views/ProductView.vue'
import SolutionsView from '../views/SolutionsView.vue'
import SupportView from '../views/SupportView.vue'
import ContactView from '../views/ContactView.vue'
import ControlPanelView from '@/views/software/ControlPanelView.vue'
import CmsView from '@/views/software/CmsView.vue'



// 1. 定义路由表
const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/products',
        name: 'Products',
        component: ProductView
    },
    {
        path: '/product/detail/:id',
        component: () => import('@/views/ProductDetailView.vue'),
    },
    {
        path: '/solutions',
        name: 'Solutions',
        component: SolutionsView
    },
    {
        path: '/support',
        name: 'Support',
        component: SupportView
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactView
    },
    {
        path: '/software/controlPanel',
        name: 'ControlPanel',
        component: ControlPanelView
    },
    {
        path: '/software/cms',
        name: 'Cms',
        component: CmsView
    },
    {
        path: '/admin',
        component: () => import('@/views/admin/LayoutView.vue'),
        children: [
            {
                path: 'login',
                name: 'Login',
                component: () => import('@/views/admin/LoginView.vue')
            },
            {
                path: 'product',
                name: 'AdminProduct',
                component: () => import('@/views/admin/ProductView.vue')
            },
            {
                path: 'product/type',
                name: 'AdminProductType',
                component: () => import('@/views/admin/ProductTypeView.vue')
            },
            {
                path: 'product/model',
                name: 'AdminProductModel',
                component: () => import('@/views/admin/ProductModelView.vue')
            },
            {
                path: 'product/add',
                component: () => import('@/views/admin/ProductFormView.vue'),
                meta: { title: '新增产品' }
            },
            // ✨ 必须补上这一个，用来接住编辑请求 ✨
            {
                path: 'product/edit/:id',
                component: () => import('@/views/admin/ProductFormView.vue'),
                meta: { title: '编辑产品' }
            }
        ]
    }
]

// 2. 创建路由实例
const router = createRouter({
    // 使用 HTML5 模式（去除 URL 中的 # 号）
    history: createWebHistory(),
    routes,
    // 可选：每次切换路由时让页面滚动到顶部
    scrollBehavior() {
        return { top: 0 }
    }
})

router.beforeEach((to) => {
    const token = localStorage.getItem('token')

    // ✨ 关键修复 1：白名单放行 ✨
    // 如果要去的就是登录页，直接放行，防止产生死循环
    if (to.path === '/admin/login') {
        return true
    }

    // ✨ 关键修复 2：拦截并重定向 ✨
    // 判断如果要去的页面路径是以 /admin 开头，且没有 token，直接 return 返回登录页
    if (to.path.startsWith('/admin') && !token) {
        return '/admin/login' // 如果你的登录页叫 /admin/login 就改成对应的路径
    }

    // 其他普通前台页面，默认放行
    return true
})

export default router